import { listCompanyAgreements } from "@hp/api-client";
import type { CompanyAgreementWithRollup } from "@hp/types";
import { COMPANY_AGREEMENTS } from "../mocks/fixtures";
import { USE_MOCK_DATA } from "./config";
import { simulateNetwork } from "./simulateNetwork";

/**
 * Every commercial agreement (PPA, fuel supply agreement, etc) HP is party
 * to, each with a real rollup of its own still-open claim candidates.
 * Backs the Overview page's "HP contracts on file" KPI tile and its
 * portfolio-scan table - not a precedent-fit score (scoring contracts
 * against golden precedent is a real feature this system does not have
 * yet, so it is not faked here). The mock branch has no real claim
 * candidates to roll up, so it fills in zeros - this path is unreachable
 * with `USE_MOCK_DATA` hardcoded false above.
 */
export function fetchCompanyAgreements(): Promise<CompanyAgreementWithRollup[]> {
  if (!USE_MOCK_DATA) return listCompanyAgreements();
  return simulateNetwork(
    COMPANY_AGREEMENTS.map((agreement) => ({
      ...agreement,
      flagged_claim_count: 0,
      flagged_claim_value_high_total: 0,
      flagged_principal_value_high_total: 0,
      flagged_carrying_cost_value_high_total: 0,
      flagged_claim_avg_confidence: null,
      recovered_claim_count: 0,
      recovered_claim_value_high_total: 0,
      recovered_principal_value_high_total: 0,
      recovered_carrying_cost_value_high_total: 0,
      recovered_claim_avg_confidence: null,
      portfolio_pipeline_status: "none",
      processing_status: "placeholder",
      source_pdf: null,
    })),
  );
}
